import {PipeTransform, Pipe} from '@angular/core';

@Pipe({name: 'isEmpty'})
export class IsEmptyPipe implements PipeTransform {
  transform(text: string): string {
    return (text && ((typeof text === 'string' &&  text.length > 0 && text !== '0') || (typeof text === 'number'))) ? text : '';
  }
}
